<template>

<div class="OTfacetsgroup">
    <h4 class="OTfacetTitle">{{ title }}</h4>
    <ul>
        <li v-for="facet in facets" class="facet OTfacet">
            <otif-checkbox :name="fieldName(facet)" :value="isSelected(facet)" :altLabel="facet.value" @input="toggleFacet(facet)"/>
        </li>
    </ul>
    <a class="clear-facets OTfacetClear">Clear Filters</a>
    <div class="clear clearfix"></div>
</div>

</template>

<script>

export default {

    data() {
        return {
            selected: {}
        }
    },

    computed: {
        fieldName() {
            return function(facet) {
                return this.$slugify(facet.name, facet.value);
            }
        },
        isSelected() {
            return function(facet) {
                return _.get(this.selected, facet.name + '.' + facet.value, false);
            }
        }
    },

    props: {
        title: {
            required: true
        },
        facets: {
            required: false,
            type: Array
        }
    },

    methods: {
        toggleFacet(facet) {
            if (!this.isSelected(facet)) {
                this.$lodash.set(this.selected, facet.name + '.' + facet.value, true);
                this.$emit('selected', facet);
            } else {
                this.$emit('deselected', facet);
                this.$lodash.set(this.selected, facet.name + '.' + facet.value, false);
            }
        },

        getFieldFromFacet(facet) {
            return {
                name: facet.name,
                label: null,
                description: null,
                values: [{
                    value: facet.value,
                    label: facet.value
                }]
            };
        }
    }
}

</script>
